import styled from 'styled-components';

export const Content = styled.div`
  padding: 1% 5%;
  margin-bottom: 70px;
`
